(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumari-hair-quiz"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.lq-wrap').forEach(initLumariQuiz);
});

function initLumariQuiz(root) {
  var steps = Array.prototype.slice.call(root.querySelectorAll('.lq-step'));
  var questionSteps = steps.filter(function (s) { return s.hasAttribute('data-question'); });
  var progressFill = root.querySelector('[data-lq-progress-fill]');
  var backBtn = root.querySelector('[data-lq-back]');
  var current = 0;
  var history = [0];

  function showStep(index) {
    steps.forEach(function (s, i) {
      s.classList.toggle('is-active', i === index);
    });
    var step = steps[index];
    var isQuestion = step.hasAttribute('data-question');
    var pct = (index / (steps.length - 1)) * 100;
    progressFill.style.width = pct + '%';
    backBtn.hidden = history.length <= 1 || !isQuestion;

    if (step.classList.contains('lq-loading')) {
      runLoadingSequence(step);
    }
    if (step.getAttribute('data-step') === '12') {
      renderGauge();
    }
  }

  function goTo(index) {
    current = index;
    history.push(index);
    showStep(current);
  }

  function goNext() {
    if (current < steps.length - 1) {
      goTo(current + 1);
    }
  }

  function goBack() {
    if (history.length > 1) {
      history.pop();
      current = history[history.length - 1];
      showStep(current);
    }
  }

  function syncOptionVisual(input) {
    var option = input.closest('.lq-option');
    if (option) {
      option.classList.toggle('is-checked', input.checked);
    }
  }

  // single-select: auto-advance
  root.querySelectorAll('input[type="radio"]').forEach(function (input) {
    input.addEventListener('change', function () {
      var group = input.name;
      root.querySelectorAll('input[name="' + group + '"]').forEach(syncOptionVisual);
      setTimeout(goNext, 250);
    });
  });

  // multi-select: toggle visual + enable continue button per step
  root.querySelectorAll('.lq-step[data-multi]').forEach(function (step) {
    var checkboxes = Array.prototype.slice.call(step.querySelectorAll('input[type="checkbox"]'));
    var continueBtn = step.querySelector('[data-lq-multi-continue]');
    checkboxes.forEach(function (box) {
      box.addEventListener('change', function () {
        syncOptionVisual(box);
        var anyChecked = checkboxes.some(function (b) { return b.checked; });
        if (continueBtn) {
          if (anyChecked) {
            continueBtn.removeAttribute('disabled');
          } else {
            continueBtn.setAttribute('disabled', 'disabled');
          }
        }
      });
    });
    if (continueBtn) {
      continueBtn.addEventListener('click', function () {
        if (!continueBtn.hasAttribute('disabled')) {
          goNext();
        }
      });
    }
  });

  root.querySelectorAll('[data-lq-continue]').forEach(function (btn) {
    btn.addEventListener('click', goNext);
  });

  root.querySelectorAll('[data-lq-skip]').forEach(function (btn) {
    btn.addEventListener('click', goNext);
  });

  backBtn.addEventListener('click', goBack);

  function getCheckedValues(selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector + ':checked'));
  }

  function getChecked(selector) {
    return root.querySelector(selector + ':checked');
  }

  function runLoadingSequence(step) {
    var items = Array.prototype.slice.call(step.querySelectorAll('[data-checklist-item]'));
    var i = 0;
    items.forEach(function (item) { item.classList.remove('is-active', 'is-done'); });
    items[0].classList.add('is-active');
    var interval = setInterval(function () {
      items[i].classList.remove('is-active');
      items[i].classList.add('is-done');
      i++;
      if (i >= items.length) {
        clearInterval(interval);
        setTimeout(goNext, 400);
        return;
      }
      items[i].classList.add('is-active');
    }, 850);
  }

  var hoogResult = {
    condition: 'Overactive', potential: 'High', confidence: 'Noticeable', timeline: '4 weeks'
  };

  function renderGauge() {
    var cfg = hoogResult;
    var conditionEl = root.querySelector('[data-stat-condition]');
    var potentialEl = root.querySelector('[data-stat-potential]');
    var confidenceEl = root.querySelector('[data-stat-confidence]');
    var timelineEl = root.querySelector('[data-stat-timeline]');

    if (conditionEl) conditionEl.textContent = cfg.condition;
    if (potentialEl) potentialEl.textContent = cfg.potential;
    if (timelineEl) timelineEl.textContent = cfg.timeline;
    if (confidenceEl) confidenceEl.textContent = cfg.confidence;
  }

  showStep(0);
}

  } catch(e) { console.error(e); }
})();
})();
